// extracted by mini-css-extract-plugin
export default {"container":"StudentBlockScreen__container___T8M7N","headerContainer":"StudentBlockScreen__headerContainer___Rv3cw","bodyContainer":"StudentBlockScreen__bodyContainer___c3MlS"};